import axios from "axios"
import { useCallback, useEffect, useState } from "react"
import { URL } from "../../config";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";


export function useFetchWithToken(url){
   const [isLoading, setIsLoading] = useState(false);
   const [error, setError] = useState(null);
   const [data, setData] = useState(null);
   const [cookies, setCookie, removeCookie] = useCookies(['user']);
 
   const makeRequest = useCallback(async (requestData) => {
      setIsLoading(true);
      setError(null);
      
         axios.get(`${URL}/${url}`,{
            headers:{
                Authorization:`Bearer ${cookies.token}`,
                'Accept':'application/json',
            }}).then((response)=>{
            setData(response.data)
            setIsLoading(false);
         }).catch((error)=>{
            // console.log('akdsjsajdkjasdjkasdjasd',error.status);
            if(error.status===403){
               setCookie('user', "", { path: '/' });
               setCookie('token', "", { path: '/' });   
            }
          setError(error)
          setIsLoading(false);
         })
      
    }, [url]);
   useEffect(()=>{
      makeRequest()
      },[url])
   return { data, isLoading, error,makeRequest};
}